
import { Component, OnInit } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/app.service';
import { ForosService } from 'src/app/services/foros.service';
import { DadosCargasService } from 'src/app/services/dados-cargas.service';

@Component({
    selector: 'app-modal-cadastro-foros',
    templateUrl: './modal-cadastro-foros.component.html',
    providers: [ForosService]
})

export class ModalCadastroForosComponent implements OnInit {

    modalRef: NgbModalRef;
    public foro: any;
    public listaEstados = [];

    constructor(
        private spinner: NgxSpinnerService,
        public toastrService: ToastrService,
        private appService: AppService,
        private forosService: ForosService,
        private dadosCargasService: DadosCargasService,
    ) {

    }

    popularNovoForo() {
        this.foro = {
            nome: '',
            estado: '',
        };
    }

    ngOnInit(): void {
        this.popularNovoForo();
        this.listaEstados = this.dadosCargasService.mockEstados();
    }

    cadastrar() {
        this.add(this.foro);
    }

    add(foro) {
        this.spinner.show();
        this.toastrService.clear();
        this.forosService.add(foro)
            .subscribe(res => {
                this.toastrService.success("Foro cadastrado.", "Sucesso");
                this.modalRef.close({ result: true, page: this.modalRef.componentInstance.page, acao: 'cadastrado' });
            }, error => {
                if (error && error.errors) {
                    this.toastrService.error(error.errors[0], 'Atenção', { timeOut: 10000 });
                }
                else {
                    this.toastrService.error('Não foi possível cadastrar o foro!', 'Atenção', { timeOut: 10000 });
                }
                this.spinner.hide();
            });
    }

    close() {
        this.modalRef.close();
    }

    dismiss() {
        this.modalRef.dismiss();
    }
}

